import React from 'react'
import "./Toggle.css"

function Toggle(props) {
    return (
        <div className="toggle-content"
        style={props.style}
        >
            <label className="toggle-switch">
                <input type="checkbox" checked={props.isTurnon? true :false} 
                onChange={props.onChange}/>
                <span className="slider"></span>
            </label>
        </div>
    )
}

export default Toggle
